import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"

export const forgetPasswordViaSMSApi = createAsyncThunk(
    'auth/forget-password-via-email',
    async (data, { rejectWithValue }) => {
        try {
            const response = await AuthAxios.post(`api/v1/login/forget_pass_token/`, { user_type: "Dealor", type: 'mobile', ...data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const forgetPasswordViaSMSSlice = createSlice({
    name: 'forget-password-via-email',
    initialState: { result: [], loading: false, error: null, message: "" },
    extraReducers: (builder) => {
        builder.addCase(forgetPasswordViaSMSApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(forgetPasswordViaSMSApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
        })
        builder.addCase(forgetPasswordViaSMSApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const forgetPasswordViaSMSReducer = forgetPasswordViaSMSSlice.reducer